module.exports = {"1":"Heikko","2":"Alle keskitason","3":"Keskitasoinen","4":"Hyvä","5":"Erinomainen","1.5":"Heikko","2.5":"Alle keskitason","3.5":"Keskitasoinen","4.5":"Erinomainen"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/fi-FI/star-ratings.json
// module id = 1302
// module chunks = 0